"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectReducer = exports.ObjectActions = void 0;
var cloneValue_1 = __importDefault(require("../utils/cloneValue"));
var ObjectActions;
(function (ObjectActions) {
    ObjectActions["ADD_ITEM"] = "ADD_ITEM";
    ObjectActions["CLONE_ITEM"] = "CLONE_ITEM";
    ObjectActions["DELETE_ITEM"] = "DELETE_ITEM";
    ObjectActions["UPDATE_ITEM"] = "UPDATE_ITEM";
    ObjectActions["UPDATE_KEY"] = "UPDATE_KEY";
    ObjectActions["SET"] = "SET";
})(ObjectActions = exports.ObjectActions || (exports.ObjectActions = {}));
function objectReducer(obj, action) {
    var _a, _b, _c;
    switch (action.action) {
        case ObjectActions.ADD_ITEM: {
            return __assign(__assign({}, obj), (_a = {}, _a[action.key] = action.value, _a));
        }
        case ObjectActions.CLONE_ITEM: {
            return __assign(__assign({}, obj), (_b = {}, _b["".concat(action.key, "_copy")] = (0, cloneValue_1.default)(obj[action.key]), _b));
        }
        case ObjectActions.DELETE_ITEM: {
            var newObj = __assign({}, obj);
            delete newObj[action.key];
            return newObj;
        }
        case ObjectActions.UPDATE_ITEM: {
            return __assign(__assign({}, obj), (_c = {}, _c[action.key] = action.value, _c));
        }
        case ObjectActions.UPDATE_KEY: {
            var newObj2 = __assign({}, obj);
            var existingValue = newObj2[action.key];
            delete newObj2[action.key];
            newObj2[action.newKey] = existingValue;
            return newObj2;
        }
        case ObjectActions.SET: {
            return action.value;
        }
        default: {
            return {};
        }
    }
}
exports.objectReducer = objectReducer;
